// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__QtHUg","question":"Question_question__1aBJi","description":"Question_description__24Cx4"};